var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x_svg__16/x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "x_svg__Vector",
    d: "M16.9999 16.9999L12 12M12 12L7 7M12 12L17 7M12 12L7 17",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
};
export default SvgX;